import { createApp, toRaw } from 'vue'
import App from './App.vue'
const app = createApp(App);

import Vant from 'vant';
import 'vant/lib/index.css'
app.use(Vant);

import router from './router'
import store from './store'
// v3-drag-zoom 全局样式（必须导入，否则无法正常使用）
import "v3-drag-zoom/dist/style.css";
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import './assets/com_scss/new_vars.scss'
app.use(ElementPlus, { locale: zhCn });

import * as ElementPlusIconsVue from '@element-plus/icons-vue'
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

import './assets/com_icon/iconfont.css'
import './assets/com_scss/common_page.scss'

import * as api from './api/index'
app.config.globalProperties.$http = api;
app.config.globalProperties.$toRaw = toRaw;
import { view_is_edit } from './utils/utils'
app.config.globalProperties.$view_is_edit = view_is_edit;
import * as utils from './utils/utils'
app.config.globalProperties.$utils = utils;
// 注册全局组件
import pageView from './components/com_components/pageView.vue'
app.component('pageView', pageView);

window.$ = require('jquery');

// 富文本编辑器
// import { Boot } from '@wangeditor/editor'
// import { MyDropPanelMenu } from '@/utils/my_editor'
// const myMenuConf = {
//     key: 'my_img',
//     factory () {
//         return new MyDropPanelMenu()
//     }
// };
// Boot.registerMenu(myMenuConf);

app.use(store).use(router).mount('#app')
// app.vue写在script里面  main.js写在app挂载完之后
const debounce = (fn, delay) => {
  let timer
   return (...args) => {
     if (timer) {
       clearTimeout(timer)
     }
    //  timer = setTimeout(() => {
    //    fn(...args)
    //  }, delay)
     timer = setTimeout(() => {
       // 检查目标元素是否还在 DOM 中
       const target = args[0]?.target
       if (target && document.contains(target)) {
         fn(...args)
       }
       // 如果元素已不在 DOM 中，跳过执行
     }, delay)
   }
}
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
   constructor(callback) {
     callback = debounce(callback, 200);
     super(callback);
   }
}